/**
 * This is the login service.
 * @memberOf Login Module
 * @namespace Login Service
 */

/**
 * @name LoginService
 * @desc Create the service.
 * @param $q
 * @param loginDataService
 * @memberOf Login Module.Login Service
 * @ngInject
 */
function loginFactory($q, loginDataService) {
    // Create the service.
    var service = {};
    return service;
}

export default loginFactory;



// WEBPACK FOOTER //
// ./src/login/login.service.js